import React, { useEffect } from 'react';
import Big from 'big.js';
import { Intent, Card, RangeSlider, NumberRange } from '@blueprintjs/core';

import cls from './Filter.module.css';

const STEP_SIZE = 0.05;

function preciseRound(number: number) {
  return Big(number).round(2).toNumber() as number;
}

interface ScoreFilterCardProps {
  value?: NumberRange;
  onChange: (value: NumberRange) => void;
}
export function ScoreFilterCard(props: ScoreFilterCardProps) {
  const { value, onChange } = props;

  const [uncontrolledValue, setUncontrolledValue] = React.useState(value ?? ([1, 10] as NumberRange));

  useEffect(() => {
    if (value !== uncontrolledValue) {
      setUncontrolledValue(value ?? ([1, 10] as NumberRange));
    }
  }, [value]);

  const onValueChange = (range: NumberRange) => {
    const value = range.map(preciseRound);
    setUncontrolledValue(value as NumberRange);
  };

  const onRelease = (range: NumberRange) => {
    const value = range.map(preciseRound);
    onChange(value as NumberRange);
  };

  return (
    <Card>
      <small className={cls.label}>SCORE</small>
      <div>
        <div className={cls.rangeSliderContainer}>
          <RangeSlider
            min={1}
            max={10}
            value={uncontrolledValue}
            showTrackFill
            stepSize={STEP_SIZE}
            intent={Intent.PRIMARY}
            onChange={onValueChange}
            onRelease={onRelease}
          />
        </div>
      </div>
    </Card>
  );
}
